import { createRouteHelpers } from "../../shared/utils/createRouteHelpers";
import { PATH_SETTINGS } from "../Settings";

export const PATH_SETTINGS_WORKSITES = `${PATH_SETTINGS}/work-site` as const;

/** Account-level work site list — no params, no filters, nothing to deep-link. */
export const routeHelpersWorksites = createRouteHelpers(
  PATH_SETTINGS_WORKSITES
);
